import { useParams } from 'react-router-dom';
import { useIsMyProfile } from 'domain/shared/employee';
import { useAuthenticationProvider } from 'infrastructure/security/authentication/AuthenticationProvider';

export const useEmployeeId = () => {
  const isMyProfile = useIsMyProfile();
  const urlId = useParams<Dictionary<string>>().id!;
  const { getUserAlias } = useAuthenticationProvider();

  return isMyProfile ? getUserAlias() : urlId;
};
